import React, { PureComponent } from "react";
import qs from "qs";

import ResetPasswordForm from "./ResetPasswordForm";
import { MAIN_PATH } from "../../AppRoutes";
import Footer from "../footer/Footer";
import {
  LoginPageWrapper,
  Logo,
  FooterWrapper,
  Content,
  Layer,
  LoginCard,
  LinkWrapper
} from "./styled";

type ResetPasswordProps = {
  requestConfirmResetPassword: (token: string) => Promise<any>;
  requestResetPassword: (
    username: string,
    newPassword: string,
    token: string
  ) => Promise<any>;
  location: any;
  history: any;
  username: string;
  setFailureMessage: (message: string | null) => void;
  failureMessage: string;
};

type ResetPasswordState = {
  showResetPassword: boolean;
  isChecking: boolean;
  token: string;
  signup: boolean;
  showPasswordResetSuccessful: boolean;
};

export default class ResetPassword extends PureComponent<
  ResetPasswordProps,
  ResetPasswordState
> {
  state = {
    showResetPassword: false,
    isChecking: true,
    token: "",
    signup: false,
    showPasswordResetSuccessful: false
  };

  componentDidMount(): void {
    const { location } = this.props;
    const { token, signup } = qs.parse(location.search, {
      ignoreQueryPrefix: true
    });
    if (signup) {
      this.setState({ signup: signup });
    }
    this.setState({ token: token });
    if (token) {
      this.props
        .requestConfirmResetPassword(token)
        .then(() =>
          this.setState({ showResetPassword: true, isChecking: false })
        )
        .catch(() => this.setState({ isChecking: false }));
    }
  }

  resetPassword = (
    username: string,
    password: string,
    confirmPassword: string
  ): Promise<any> => {
    const { token } = this.state;
    const { requestResetPassword } = this.props;

    return requestResetPassword(username, password, token).then(() =>
      this.setState({ showPasswordResetSuccessful: true })
    );
  };

  showResetPassword = () => {
    const { setFailureMessage, failureMessage } = this.props;
    const {
      showResetPassword,
      showPasswordResetSuccessful,
      signup
    } = this.state;
    if (showResetPassword && !showPasswordResetSuccessful) {
      console.log(failureMessage);
      return (
        <ResetPasswordForm
          resetPassword={this.resetPassword}
          failureMessage={failureMessage}
          username={this.props.username}
          setFailureMessage={setFailureMessage}
          signup={signup}
        />
      );
    }
    return null;
  };

  showInvalidLink = () => {
    const { history } = this.props;
    const { showResetPassword, signup } = this.state;
    if (!showResetPassword) {
      return (
        <LoginCard>
          <div
            style={{
              color: "#fff",
              padding: "1rem"
            }}
          >
            The password {signup ? "creation" : "reset"} link is no longer
            valid.
          </div>
          <div
            style={{
              color: "#fff",
              padding: "1rem 1rem 3rem 1rem",
              textAlign: "center",
              width: "100%"
            }}
          >
            {signup
              ? "Please go back to the login screen and sign up again."
              : "Please request another password reset email from the login screen."}
          </div>
          <LinkWrapper onClick={() => history.push(MAIN_PATH)}>
            Back To Login
          </LinkWrapper>
        </LoginCard>
      );
    }
    return null;
  };

  showPasswordResetSuccessful = () => {
    const { history } = this.props;
    const { showPasswordResetSuccessful, signup } = this.state;

    if (showPasswordResetSuccessful) {
      return (
        <LoginCard>
          <div
            style={{
              color: "#fff",
              padding: "1rem 1rem 3rem 1rem",
              textAlign: "center"
            }}
          >
            Your password has been {signup ? "created" : "changed"}. You can now
            log in.
          </div>
          <LinkWrapper onClick={() => history.push(MAIN_PATH)}>
            Back To Login
          </LinkWrapper>
        </LoginCard>
      );
    }
    return null;
  };

  render() {
    const { isChecking } = this.state;

    if (isChecking) {
      return (
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <div className="spinner-border" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      );
    }

    const showResetPwdUI = this.showResetPassword();
    const showInvalidLinkUI = this.showInvalidLink();
    const showPwdSuccessUI = this.showPasswordResetSuccessful();

    return (
      <LoginPageWrapper>
        <Logo>
          <img src="/mps-logo.png" width="350" alt="Morgan Project Services" />
        </Logo>
        <Content>
          <Layer>
            {showResetPwdUI}
            {showInvalidLinkUI}
            {showPwdSuccessUI}
          </Layer>
        </Content>
        <FooterWrapper>
          <Footer />
        </FooterWrapper>
      </LoginPageWrapper>
    );
  }
}
